import React from 'react'
import { observer } from 'mobx-react'
import { CallbackOnPipe, Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import Button from 'ui/buttons/Button'
import { Translation } from '@morningtrain/react-translations'
import { CloseModalOnPipe, ExecuteOperationOnPipe, Form, OpenModalOnPipe, Operation } from '@morningtrain/react-resources'
import * as Auth from '@morningtrain/react-auth'
import Modal from 'widgets/modals/Modal'
import { SubmitButton } from 'ui/buttons'
import { TextArea } from '@morningtrain/react-fields'

function NotifyAboutAdjustments (props) {
  const modalRef = React.useRef()

  let _resolve = null

  const handleOnSubmit = (data) => {
    if (_resolve !== null) {
      _resolve(data)
    }
  }

  const handleOnPipe = (payload) => {
    return new Promise((resolve, reject) => {
      _resolve = data => {
        payload.data = data
        resolve(data)
      }
    })
  }

  return (
    <Auth.CanUseModel permission='api.shifts.schedule.notify_about_adjustments'>
      <Modal ref={modalRef}>
        <Operation namespace='api' resourceName='shifts.schedule' operationName='notify_about_adjustments'>
          <Form onSubmit={handleOnSubmit} submitTo='notify_about_adjustments'>
            <TextArea name='notify_message' />
            <SubmitButton>
              Send
            </SubmitButton>
          </Form>
        </Operation>
      </Modal>
      <Pipeline>
        <TriggerPipelineOnClick>
          <Button>
            <Translation name='generic.notify_about_adjustments' defaultValue='Notify about adjustments' />
          </Button>
        </TriggerPipelineOnClick>
        <OpenModalOnPipe modalRef={modalRef} />
        <CallbackOnPipe callback={handleOnPipe} />
        <CloseModalOnPipe modalRef={modalRef} />
        <ExecuteOperationOnPipe operationName='fetch' />
      </Pipeline>
    </Auth.CanUseModel>
  )
}

export default observer(NotifyAboutAdjustments)
